import { type FC } from 'react';
import { NotesCellProps } from './NotesCell.types';
import { NoteCounter, Text, Tooltip, Flex } from '@/_components';

export const NotesCell: FC<NotesCellProps> = ({ notes }) => {
  const visibleNotes = notes.filter((note) => !note.removed);
  const noteCount: number = visibleNotes?.length ?? 0;

  const notesList: React.ReactNode = (
    <Flex isColumn={true} gap={2}>
      {visibleNotes?.map((note, key) => {
        return (
          <Text type="tiny" color="currentcolor" key={key}>
            {key + 1}. {note.text}
          </Text>
        );
      })}
    </Flex>
  );

  if (noteCount > 0) {
    return (
      <Tooltip>
        <Tooltip.Content>{notesList}</Tooltip.Content>
        <Tooltip.Trigger>
          <NoteCounter noteCount={noteCount} />
        </Tooltip.Trigger>
      </Tooltip>
    );
  }

  return <NoteCounter noteCount={noteCount} />;
};
